<template>
  <div>
    <form class="form" @submit.prevent="updatePassword">
      <div class="form-group">
        <label class="form-label required" for="current-password">{{ $t('password.current') }}</label>
        <input
          type="password"
          class="form-control"
          :class="{'is-invalid' : error.current_password}"
          id="current-password"
          v-model="form.current_password"
          :disabled="loading"
        />
        <div class="invalid-feedback" v-show="error.current_password">
          <span>{{ error.current_password }}</span>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label required" for="new-password">{{ $t('password.new') }}</label>
        <input
          type="password"
          class="form-control"
          :class="{'is-invalid' : error.new_password}"
          id="new-password"
          v-model="form.new_password"
          :disabled="loading"
        />
        <div class="invalid-feedback" v-show="error.new_password">
          <span>{{ error.new_password }}</span>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label required" for="confirm-new-password">{{ $t('password.new_confirm') }}</label>
        <input
          type="password"
          class="form-control"
          :class="{'is-invalid' : error.new_password_confirmation}"
          id="confirm-new-password"
          v-model="form.new_password_confirmation"
          :disabled="loading"
        />
        <div class="invalid-feedback" v-show="error.new_password_confirmation">
          <span>{{ error.new_password_confirmation }}</span>
        </div>
      </div>

      <button type="submit" class="button button-primary" :disabled="loading">
        <span v-show="loading">{{ $t('common.button.update') }}</span>
        <span v-show="!loading">{{ $t('common.button.update') }}</span>
      </button>
    </form>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {api} from "../../../config";

  export default {
    data() {
      return {
        loading: false,
        form: {
          current_password: '',
          new_password: '',
          new_password_confirmation: ''
        },
        error: {
          current_password: '',
          new_password: '',
          new_password_confirmation: ''
        }
      }
    },
    methods: {
      updatePassword() {
        let self = this;
        
        this.loading = true;
        
        self.$store.dispatch('showLoading', true);
        
        axios.post(api.updateUserPassword, this.form)
          .then((res) => {
            self.loading = false;
            
            self.$store.dispatch('showLoading', false);
            
            self.$emit('updateSuccess');
          })
          .catch(err => {
            (err.response.data.error)
              ? self.setErrors(err.response.data.error)
              : self.clearErrors();

            self.loading = false;
            self.$store.dispatch('showLoading', false);
          });
      },
      setErrors(errors) {
        this.error.current_password = errors.current_password ? errors.current_password[0] : null;
        this.error.new_password = errors.new_password ? errors.new_password[0] : null;
        this.error.new_password_confirmation = errors.new_password_confirmation ? errors.new_password_confirmation[0] : null;
      },
      clearErrors() {
        this.error.current_password = null;
        this.error.new_password = null;
        this.error.new_password_confirmation = null;
      }
    }
  }
</script>